import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';
import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';

export default new ValueExpression({
  identifier: 'lma-anomalies.uv.distanceviolation.DV250mNB.count',
  label: 'Distanzverstoß Nachbarschaftsabgabe',
  definition: getDefinitionByName('Distanzverstoß Nachbarschaftsabgabe'),
  positiveDirection: PositiveDirection.custom,
});
